import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { CalendarClockIcon } from './icons'

interface AvailabilityEmptyStateProps {
	onGetStarted: () => void
}

export function AvailabilityEmptyState({ onGetStarted }: AvailabilityEmptyStateProps) {
	const { t } = useTranslation('common')

	return (
		<div className="flex items-center justify-center h-full p-10">
			<div className="w-full max-w-md bg-white rounded-2xl border border-grey-100 shadow-sm px-10 py-12 flex flex-col items-center text-center gap-4">
				<div className="flex items-center justify-center size-14 rounded-full bg-brand-50 text-brand-600">
					<CalendarClockIcon />
				</div>

				<div className="flex flex-col gap-2">
					<h1 className="text-xl font-semibold text-grey-900">
						{t('account.availability.empty_state.title')}
					</h1>
					<p className="text-sm text-grey-500">
						{t('account.availability.empty_state.description')}
					</p>
				</div>

				<Button
					type="button"
					size="lg"
					onClick={onGetStarted}
					className="mt-2 bg-brand-600 text-white hover:bg-brand-700"
				>
					{t('account.availability.empty_state.cta')}
				</Button>

				<p className="text-xs text-grey-400">
					{t('account.availability.empty_state.effort')}
				</p>
			</div>
		</div>
	)
}
